// removed by extract-text-webpack-plugin
module.exports = {"root":"_2Xylk"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/People/elements/TalkList.sass
// module id = ./src/modules/People/elements/TalkList.sass
// module chunks = 6